var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36.5085 27.1749L26.4917 17.1581C26.0361 16.7025 25.2974 16.7025 24.8418 17.1581L23.2006 18.7993C22.7454 19.2545 22.7449 19.9923 23.1994 20.4481L30.7301 27.9998L23.1994 35.5515C22.7449 36.0073 22.7454 36.7451 23.2006 37.2003L24.8418 38.8415C25.2974 39.2971 26.0361 39.2971 26.4917 38.8415L36.5085 28.8248C36.9641 28.3692 36.9641 27.6305 36.5085 27.1749Z",
  fill: "white"
})));
export default SvgArrowRight1;